/* TapeUp — брояч в промо лентата. Нулира се в 23:59 софийско време. */
(function () {
  var CUTOFF = [23, 59];
  var LABEL = ' \u00b7 изтича след ';

  function sofiaNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
  }
  function remaining() {
    var now = sofiaNow(), end = new Date(now);
    end.setHours(CUTOFF[0], CUTOFF[1], 0, 0);
    if (end <= now) end.setDate(end.getDate() + 1);
    var s = Math.floor((end - now) / 1000);
    return [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60]
      .map(function (n) { return String(n).padStart(2, '0'); }).join(':');
  }
  function tick() {
    var value = remaining();
    /* Броячът върви само в горната промо лента, не и в розовата с мотото. */
    var hosts = document.querySelectorAll(
      '.announcement-bar__message:not([id*="tapeup-motto-bar"] .announcement-bar__message)');
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i].querySelector('.tapeup-bar-clock');
      if (!el) {
        el = document.createElement('span');
        el.className = 'tapeup-bar-clock';
        hosts[i].appendChild(el);
      }
      el.textContent = LABEL + value;
    }
  }
  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Стикер „−50% САМО ДНЕС" върху галерията. */
(function () {
  function place() {
    var host = document.querySelector('.product__media-wrapper');
    if (!host || host.querySelector('.tapeup-sticker')) return;
    var b = document.createElement('div');
    b.className = 'tapeup-sticker';
    b.innerHTML = '<span class="tapeup-sticker__big">&minus;50%</span>' +
                  '<span class="tapeup-sticker__small">САМО ДНЕС</span>';
    host.appendChild(b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();


/* „Опаковка подарък“ в бонусите се вижда само при пакета 2+1 — първата опция в избора. */
(function () {
  function sync() {
    var gift = document.querySelector('.tapeup-bonus__item--gift');
    var group = document.querySelector('.quantity-breaks-container');
    if (!gift || !group) return;
    var radios = group.querySelectorAll('input[type="radio"]');
    var idx = 0;
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) { idx = i; break; }
    gift.hidden = idx !== 0;
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity-breaks-container')) sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();

/* Собствен преглед на продуктовите снимки: на цял екран, плъзгане между
   всички снимки, стрелки, брояч и голям бутон за затваряне. Заменя
   вградения модал, който показва снимките една под друга. */
(function () {
  function bigSrc(img) {
    var set = (img.getAttribute('srcset') || '').split(',').map(function (s) { return s.trim().split(' ')[0]; }).filter(Boolean);
    var src = set.length ? set[set.length - 1] : (img.currentSrc || img.src);
    return src.replace(/([?&])width=\d+/, '$1width=1600');
  }
  function build(srcs, start) {
    var box = document.createElement('div');
    box.className = 'tu-lb';
    box.innerHTML =
      '<button class="tu-lb__close" aria-label="Затвори">&times;</button>' +
      '<div class="tu-lb__track">' + srcs.map(function (s) {
        return '<div class="tu-lb__slide"><img src="' + s + '" alt=""></div>';
      }).join('') + '</div>' +
      '<button class="tu-lb__nav tu-lb__nav--prev" aria-label="Предишна">&#8249;</button>' +
      '<button class="tu-lb__nav tu-lb__nav--next" aria-label="Следваща">&#8250;</button>' +
      '<div class="tu-lb__count"></div>';
    document.body.appendChild(box);
    document.documentElement.classList.add('tu-lb-open');
    var track = box.querySelector('.tu-lb__track');
    var count = box.querySelector('.tu-lb__count');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function upd() { count.textContent = (idx() + 1) + ' / ' + srcs.length; }
    function go(i) { i = Math.max(0, Math.min(srcs.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function close() { box.remove(); document.documentElement.classList.remove('tu-lb-open'); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') go(idx() + 1); if (e.key === 'ArrowLeft') go(idx() - 1); }
    track.scrollLeft = start * track.clientWidth;
    upd();
    track.addEventListener('scroll', upd, { passive: true });
    box.querySelector('.tu-lb__close').addEventListener('click', close);
    box.querySelector('.tu-lb__nav--prev').addEventListener('click', function () { go(idx() - 1); });
    box.querySelector('.tu-lb__nav--next').addEventListener('click', function () { go(idx() + 1); });
    box.addEventListener('click', function (e) { if (e.target.classList.contains('tu-lb__slide')) close(); });
    document.addEventListener('keydown', key);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('.product__media-list .product__modal-opener, .product__media-list .product__media-toggle');
    if (!opener) return;
    var list = opener.closest('.product__media-list');
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > .product__media-item'));
    var srcs = [], start = 0;
    items.forEach(function (it) {
      var img = it.querySelector('img');
      if (!img) return;
      if (it.contains(opener)) start = srcs.length;
      srcs.push(bigSrc(img));
    });
    if (!srcs.length) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    build(srcs, start);
  }, true);
})();
